import { graphql } from '@/generated/gql';

export const CONTRACT_DEMAND_CREATE_FROM_COVERAGE_WITH_RULE_BUILDER = graphql(/* GraphQL */ `
  mutation ContractDemandCreateFromCoveragePredictionWithRuleBuilder(
    $data: TsrctContractDemandCreateFromCoveragePredictionInput!
  ) {
    tesseract {
      contractDemandCreateFromCoveragePrediction: contractDemandCreateFromCoveragePredictionV2(data: $data) {
        id
        sequenceNumber
        priority
        tagIds
        responsibleUserId
        createdAt
        updatedAt
        competitiveBiddingRule {
          id
          variant
        }
        demandRequest {
          id
          createdAt
          requestedAt
          totalValue
          currency
          summary
        }
      }
    }
  }
`);
